@if (dataSource.data.length ===0 && !isLoadingData()) {
  <tkc-no-data/>
} @else {
  <mic-year-scroller class="year-scroller" [(year)]="startYear" [leftDisabled]=!canSelectPreviousYear() />

  <div id="tab-content">
    <mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="seat">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'stock.table.seat' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.tireSpec.seat }}</mat-cell>
        <mat-footer-cell *matFooterCellDef></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="tireSpec">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="column-tire-spec">{{ 'stock.table.tireSpec' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-tire-spec">{{ element.tireSpec.specification }}</mat-cell>
        <mat-footer-cell *matFooterCellDef class="column-tire-spec"></mat-footer-cell>
      </ng-container>

      <ng-container matColumnDef="cai">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'stock.table.cai' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.tireSpec.cai }}</mat-cell>
        <mat-footer-cell *matFooterCellDef>{{ 'stock.table.total' | translate }}</mat-footer-cell>
      </ng-container>


      @for (monthNumber of monthsNumbersToDisplay; track monthNumber) {
        <ng-container matColumnDef="{{ monthNumber }}">
          <mat-header-cell *matHeaderCellDef class="table-number">
            <div class="month-header">
              <span>{{ 'common.months.' + monthNumber | translate }}</span>
              <span class="year">{{ getYearForMonth(monthNumber) }}</span>
            </div>
          </mat-header-cell>
          <mat-cell *matCellDef="let element" [ngClass]="getMonthClass(element.frozenZone, monthNumber)" class="table-data">
            <div class="input-edited-wrapper">
              @if (element.ongoingDeliveryByMonth?.[getFirstDayOfMonth(monthNumber)] && element.ongoingDeliveryByMonth?.[getFirstDayOfMonth(monthNumber)]?.modified) {
                <span class="input-edited-marker"></span>
              }
              <ng-container>
                <input matInput
                       type="text"
                       maxlength="3"
                       nxNoScroll
                       [mask]="digitMask"
                       [patterns]="digitPatterns"
                       class="tkc-input"
                       [formControl]="getQuantityControl(element.tireSpec.tireSpecId, monthNumber)"
                       (keydown.enter)="updateColumns(element, monthNumber, getQuantityControl(element.tireSpec.tireSpecId, monthNumber))"
                       (change)="updateColumns(element, monthNumber, getQuantityControl(element.tireSpec.tireSpecId, monthNumber))"/>
              </ng-container>
            </div>
          </mat-cell>
          <mat-footer-cell *matFooterCellDef class="table-data tkc-number">
            {{ getTotalForMonth(monthNumber) }}
          </mat-footer-cell>
        </ng-container>
      }

      <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: columns"></mat-row>
      <mat-footer-row *matFooterRowDef="columns"></mat-footer-row>
    </mat-table>
  </div>

  <mic-year-scroller class="year-scroller" [(year)]="startYear" [leftDisabled]=!canSelectPreviousYear() />

  <div id="tab-content-footer" class="card-side-padding card-bottom-padding">
    <span class="frozen" style="width: 1.5em; height: 1.5em"></span>
    <span>{{ 'common.legend.frozenZone' | translate }}</span>
  </div>
}
